module.exports = __webpack_public_path__ + "static/media/heroicons-solid.b140406b.svg";